import React, { ComponentType } from 'react';
import { AuthTemplate } from '@identity/components/auth-template/auth-template';

export function PublicRoute({ page: Page }: { page: ComponentType }) {
  return (
    <AuthTemplate>
      <Page />
    </AuthTemplate>
  );
}
